import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { MenuProvider } from '../../sharedComponents/MenuContext';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);
      
      if (mobile) {
        setSidebarCollapsed(false);
        setMobileSidebarOpen(false);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => {
    if (isMobile) {
      setMobileSidebarOpen(!mobileSidebarOpen);
    } else {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  const closeMobileSidebar = () => {
    if (isMobile) {
      setMobileSidebarOpen(false);
    }
  };

  return (
    <MenuProvider>
      <div className="flex min-h-screen bg-gray-50">
        {/* Mobile Overlay */}
        {isMobile && mobileSidebarOpen && (
          <div
            className="fixed inset-0 bg-black/50 z-40 lg:hidden"
            onClick={closeMobileSidebar}
          />
        )}

        {/* Sidebar */}
        <Sidebar
          collapsed={sidebarCollapsed}
          onToggle={toggleSidebar}
          isMobile={isMobile}
          mobileOpen={mobileSidebarOpen}
          onMobileClose={closeMobileSidebar}
        />

        {/* Main Content */}
        <main
          className={`flex-grow min-h-screen transition-all duration-300 w-full ${
            isMobile
              ? 'ml-0'
              : sidebarCollapsed
              ? 'ml-[5.4rem]'
              : 'ml-64'
          }`}
        >
          <Header
            sidebarCollapsed={sidebarCollapsed}
            isMobile={isMobile}
            onMenuClick={toggleSidebar}
          />

          <div className="p-4 sm:p-6 md:p-8 lg:px-12 lg:py-8 mt-16 sm:mt-20">
            {children}
          </div>
        </main>
      </div>
    </MenuProvider>
  );
};

export default Layout;